import { Component, NgZone, OnInit, Input, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, Validators } from '@angular/forms';
import { ListCompanies } from '../models/company.model';
import { CompanyService } from './../services/company.service';
import { UserService } from './../services/user.service';
import { ProjectElement } from '../models/project.model';
import { ProjectService } from './../services/project.service';
import { ZoneElement, ListZones, ListCountries } from './../models/zone.model';
import { ZoneService } from '../services/zone.service';
import { MenusComponent } from './../menus/menus.component';
import { DialogService } from '../services/dialog.service';
import { LanguageService } from '../services/language.service';
import { DateAdapter } from '@angular/material/core';
import { TranslocoService } from '@jsverse/transloco';
import { ListUsers } from '../models/user.model';
import { StorageService } from '../services/storage.service';

@Component({
  selector: 'app-project',
  templateUrl: './project.component.html',
  styleUrl: './project.component.css'
})

export class ProjectComponent  implements OnInit {

  constructor(public ngZone: NgZone, private router: Router, private route: ActivatedRoute,
              private companyService: CompanyService, private projectService: ProjectService,
              private zoneService: ZoneService, private menusComponent: MenusComponent,
              private dialogService: DialogService, private dateAdapter: DateAdapter<Date>,
              private langService: LanguageService, private translocoService: TranslocoService,
              private userService: UserService, public storageService: StorageService) {
                this.dateAdapter.setLocale('es-ES');
              }

  public titleProject = "Proyecto";
  public new = false;
  id: number=0;
  companyId: number=0;
  lstCountries:ListCountries[] = []
  zoneIds?: [];
  companyControl = new FormControl('', [Validators.required]);
  managersControl = new FormControl('', [Validators.required]);
  zonesControl = new FormControl('', [Validators.required]);

  lstUsers: ListUsers[] = [];
  lstCompanies: ListCompanies[] = [];
  lstCompanyZones: ListZones[] = [];
  item: any = [];

  // ── Notification emails ───────────────────────────────────────────────────
  notificationEmailsList: { id: number; email: string; label: string | null }[] = [];
  emailToAdd = '';
  invalidEmailToAdd = false;

  // ── Notification contacts ─────────────────────────────────────────────────
  notificationContactsList: { id: number; user_id: number; first_name: string; last_name: string }[] = [];
  userToAdd: number | null = null;

  name_Input: string="";
  start_date_Input: Date= new Date();
  country_Input: string="";
  company_Selected: number=0;
  manager_Selected: number=0;
  zones_Selected: number[] = [];

  project: ProjectElement = {
    id: 0,
    name: '',
    start_date: new Date(),
    country: '',
    company_id: 0,
    manager_id: 0,
    zone_id: 0,
    zoneIds: []
  }

  ngOnInit(): void {
    this.route.queryParams.
      subscribe(params => {
        this.id = (params['id']);
        this.companyId = (params['companyId']);
      });
    
    const currentLang = this.langService.getLang();
    
    if(this.id > 0 && this.companyId > 0){
      this.new = false
      this.translocoService.selectTranslate('project.titleEdit')
      .subscribe((translatedTitle: string) => {
        this.titleProject = translatedTitle;
      });

      //GET
      const req=this.projectService.getProjectById(this.id, this.companyId);
      req.subscribe({
        next: (res) => {
          this.item = res;
          if(this.item.data != null){
            this.name_Input = this.item.data.name;
            this.start_date_Input = new Date(this.item.data.start_date);
            this.country_Input = this.item.data.country;
            this.company_Selected = this.item.data.company_id;
            this.manager_Selected=this.item.data.manager_id;
            this.zones_Selected = [this.item.data.zone_id];
          }
        },
        error: (e) => {
          console.error(e);
          let msg = e.error.message;
        },
      });
      this.loadNotificationData();

    }else{
      this.new = true
      this.company_Selected=this.storageService.companyId
      this.companyId = this.storageService.companyId
      this.translocoService.selectTranslate('project.titleNew')
      .subscribe((translatedTitle: string) => {
        this.titleProject = translatedTitle;
      });
    }

    this.lstCompanies=this.companyService.getCompaniesListByRol(this.storageService.roleId,
                                                                this.companyId);
    this.lstCompanyZones=this.zoneService.getCompanyZonesList(this.companyId);
    this.lstUsers=this.userService.getUsersList(this.companyId)
    this.lstCountries=this.zoneService.getCountries();
  }

  onGuardarItm(){
    console.log(this.company_Selected)
    if (!(this.company_Selected>0)){
      return;
    }
    let msg:string="";
    if (this.new ){
      //ADD
      this.project = {
        id: 0,
        name: this.name_Input,
        start_date: new Date(this.start_date_Input),
        country: this.country_Input,
        company_id: this.company_Selected,
        manager_id: this.manager_Selected,
        zoneIds: this.zones_Selected,
      }
      this.projectService.addProject(this.project, this.companyId)
      .subscribe({
        next: (res) => {
          msg = res.message;
          console.log(msg);
          this.msgDialog(msg, '', true, 'O');
        },
        error: (e) => {
          msg = e.error.message;
          console.error(e);
          this.msgDialog('ERROR', msg, false, 'E');
        },
      });
    }else{
      //UPDATE
      this.project = {
        id: this.id,
        name: this.name_Input,
        start_date: new Date(this.start_date_Input),
        country: this.country_Input,
        company_id: this.company_Selected,
        manager_id: this.manager_Selected,
        zoneIds: this.zones_Selected,
      }
      this.projectService.updateProject(this.id, this.project, this.companyId)
      .subscribe({
        next: (res) => {
          msg = res.message;
          console.log(msg);
          this.msgDialog(msg, '', true, 'O');
        },
        error: (e) => {
          msg = e.error.message;
          console.error(e);
          this.msgDialog('ERROR', msg, false, 'E');
        },
      });
    }
  }

  msgDialog(msgShow:string, msg2Show:string, isOK:boolean, type:string){
    this.dialogService.confirmDialog({
      title: 'Proyecto',
      message: msgShow,
      message2: msg2Show,
      confirmText: 'OK',
      cancelText: '',
      showConfirmBox: false,
      dialogType: type,
    })
    .subscribe((yes) => {
      if (isOK) {
        setTimeout(() => {
          this.router.navigate(['projects']);
        }, 1000);
      }
    });
  }

  EliminarItm(){
    //DELETE
    let msg:string="";
    this.projectService.deleteProject(this.id, this.companyId)
    .subscribe({
      next: (res) => {
        msg = res.message;
        console.log(msg);
        this.msgDialog(msg, '', true, 'O');
      },
      error: (e) => {
        msg = e.error.message;
        console.error(e);
        this.msgDialog('ERROR', msg, false, 'E');
      },
    });
  }

  onEliminarItm() {
    this.dialogService.confirmDialog({
      title: this.translocoService.translate('project.msgTitle'),
      message: this.translocoService.translate('project.msgMessage'),
      message2: this.translocoService.translate('project.msgMessage2'),
      confirmText: this.translocoService.translate('project.confirmText'),
      cancelText: this.translocoService.translate('project.cancelText'),
        showConfirmBox: true,
        dialogType: 'A',
    })
    .subscribe((yes) => {
      if (yes) {
        this.EliminarItm();
        console.log('Si Eliminar.');
      }
    });
  }

  onSelectCompany(companyId: number){
    if (this.storageService.roleId) {
      this.zones_Selected=[];
      this.lstCompanyZones=[];
      this.lstCompanyZones=this.zoneService.getCompanyZonesList(companyId);
    }
  }

  loadNotificationData(): void {
    this.projectService.getNotificationEmails(this.id, this.companyId).subscribe({
      next: (res: any) => { this.notificationEmailsList = res.data || []; },
      error: (e: any)  => console.error(e),
    });
    this.projectService.getNotificationContacts(this.id, this.companyId).subscribe({
      next: (res: any) => { this.notificationContactsList = res.data || []; },
      error: (e: any)  => console.error(e),
    });
  }

  addNotificationEmail(): void {
    const email = this.emailToAdd.trim().toLowerCase();
    if (!this.isValidEmail(email)) { this.invalidEmailToAdd = true; return; }
    this.invalidEmailToAdd = false;
    this.projectService.addNotificationEmail(this.id, this.companyId, email).subscribe({
      next: (res: any) => {
        this.notificationEmailsList.push(res.data);
        this.emailToAdd = '';
      },
      error: (e: any) => this.msgDialog('ERROR', e.error?.message, false, 'E'),
    });
  }

  removeNotificationEmail(id: number): void {
    this.projectService.deleteNotificationEmail(this.id, this.companyId, id).subscribe({
      next: ()        => { this.notificationEmailsList = this.notificationEmailsList.filter(e => e.id !== id); },
      error: (e: any) => this.msgDialog('ERROR', e.error?.message, false, 'E'),
    });
  }

  isValidEmail(email: string): boolean { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email); }

  addNotificationUser(): void {
    if (!this.userToAdd) return;
    const userId = this.userToAdd;
    this.projectService.addNotificationContact(this.id, this.companyId, userId).subscribe({
      next: (res: any) => {
        const user = this.lstUsers.find(u => u.value === userId);
        const parts = user ? user.viewValue.split(' ') : [];
        this.notificationContactsList.push({
          id:         res.data.id,
          user_id:    userId,
          first_name: parts[0] || '',
          last_name:  parts.slice(1).join(' ') || '',
        });
        this.userToAdd = null;
      },
      error: (e: any) => this.msgDialog('ERROR', e.error?.message, false, 'E'),
    });
  }

  removeNotificationUser(id: number): void {
    this.projectService.deleteNotificationContact(this.id, this.companyId, id).subscribe({
      next: ()        => { this.notificationContactsList = this.notificationContactsList.filter(c => c.id !== id); },
      error: (e: any) => this.msgDialog('ERROR', e.error?.message, false, 'E'),
    });
  }

}
